<template>
  <b-container fluid>
    <iq-card>
      <template v-slot:headerTitle>
          <h4 class="card-title">{{ $t('production_store.stock_report') }}</h4>
      </template>
      <template v-slot:body>
        <b-row>
            <b-col lg="4" sm="12">
                <b-form-group
                    class="row"
                    label-cols-sm="5"
                    :label="$t('production_store.pro_category')"
                    label-for="category_id">
                    <b-form-select
                        plain
                        v-model="search.category_id"
                        :options="categoryList"
                        id="category_id">
                        <template v-slot:first>
                            <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                        </template>
                    </b-form-select>
                </b-form-group>
            </b-col>
            <b-col lg="4" sm="12">
                <b-form-group
                    class="row"
                    label-cols-sm="6"
                    :label="$t('production_store.pro_sub_category')"
                    label-for="sub_category_id">
                    <b-form-select
                        plain
                        v-model="search.sub_category_id"
                        :options="subCategoryList"
                        id="sub_category_id">
                        <template v-slot:first>
                            <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                        </template>
                    </b-form-select>
                </b-form-group>
            </b-col>
            <b-col lg="4" sm="12">
                <b-form-group
                    class="row"
                    label-cols-sm="5"
                    :label="$t('production_store.pro_name')"
                    label-for="product_id">
                    <b-form-select
                        plain
                        v-model="search.product_id"
                        :options="productList"
                        id="product_id">
                        <template v-slot:first>
                            <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                        </template>
                    </b-form-select>
                </b-form-group>
            </b-col>
            <b-col class="text-right">
              <b-button type="button" variant="primary" @click="searchData">{{ $t('globalTrans.search')}}</b-button>
            </b-col>
        </b-row>
      </template>
    </iq-card>
    <b-row>
      <b-col md="12">
        <iq-card>
          <template v-slot:body>
            <b-row v-if="loaded">
              <b-col xs="12" sm="12" md="3" class="text-right mt-3">
                <b-img :src="`${ reportHeadData.reportHeadColumn[0].image }`" fluid alt="BD Image" style="width:35%;border-radius:50%;"></b-img>
              </b-col>
              <b-col xs="12" sm="12" md="6" class="text-center mt-2">
                <h3 class="text-bold">{{ $t('production_store.govt_info') }}</h3>
                <h4 class="text-center text-dark">{{ reportHeadData.orgName }}</h4>
                <span class="text-center text-dark">{{ reportHeadData.heading }}</span><br>
                <span class="text-center text-dark">{{ reportHeadData.address }}</span><br>
                <div class="titleDiv">
                  <span class="text-center text-dark reportTitle" style="font-weight:bold;">{{ $t('production_store.stock_report') }}</span><br>
                </div>
              </b-col>
              <b-col xs="12" sm="12" md="3" class="mt-4 text-right">
                <b-button-group>
                  <b-button @click="pdfExport" variant="success">{{  $t('globalTrans.export_pdf') }}</b-button>
                  <b-button variant="warning">
                    <export-excel
                      :data="excelData"
                      :title="headerValue"
                      worksheet="Report Sheet"
                      name="stock_report.xls">
                      {{ $t('globalTrans.export_excel') }}
                    </export-excel>
                  </b-button>
                </b-button-group>
              </b-col>
            </b-row>
            <b-overlay :show="loadingState">
            <b-row class="mt-4">
                <b-col lg="12" xs="12" md="12">
                    <b-table thead-class="bg-primary" bordered hover :items="report_data" :fields="columns" aria-hidden="loading | listReload ? 'true' : null" :emptyText="$t('globalTrans.noDataFound')" show-empty>
                      <template v-slot:cell(index)="data">
                        {{ $n(data.index + 1) }}
                      </template>
                      <template v-slot:cell(category_name)="data">
                        {{ getCategoryName(data.item) }}
                      </template>
                      <template v-slot:cell(sub_category_name)="data">
                        <span v-for="(item, idx) in getSubCategoryName(data.item)" :key="idx">
                          <div>{{ item }}</div>
                        </span>
                      </template>
                      <template v-slot:cell(product_name)="data">
                        <span v-for="(item, idx) in getProductName(data.item)" :key="idx">
                          <div>{{ item }}</div>
                        </span>
                      </template>
                      <template v-slot:cell(unit_id)="data">
                        <span v-for="(item, idx) in getUnitName(data.item)" :key="idx">
                          <div>{{ item }}</div>
                        </span>
                      </template>
                      <template v-slot:cell(current_stock)="data">
                        <span v-for="(item, idx) in getCurrentStock(data.item)" :key="idx">
                          <div>{{ item }}</div>
                        </span>
                      </template>
                    </b-table>
                    <!-- <b-pagination
                    v-model="pagination.currentPage"
                    :per-page="pagination.perPage"
                    :total-rows="pagination.totalRows"
                    @input="searchData"
                    /> -->
                </b-col>
            </b-row>
            </b-overlay>
          </template>
        </iq-card>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
import { mapGetters } from 'vuex'
import RestApi, { productionServiceBaseUrl } from '@/config/api_config'
import { productStockReportList } from '../../api/routes'
import RouteBasedList from '@/mixins/route-base-list'
import ExportPdf from './export-pdf_details'
import ReportHeading from '@/Utils/report-head'
import excel from 'vue-excel-export'
import Vue from 'vue'
Vue.use(excel)
export default {
  mixins: [RouteBasedList],
  data () {
    return {
      search: {
        category_id: 0,
        sub_category_id: 0,
        product_id: ''
      },
      report_data: [],
      subCategoryList: [],
      productList: [],
      rows: [],
      reportHeadData: '',
      loaded: false
    }
  },
  created () {
    this.headerName()
  },
  computed: {
    headerValue: function () {
        const headerVal = []
        if (this.$i18n.locale === 'en') {
            headerVal[0] = this.reportHeadData.orgName
            headerVal[1] = this.reportHeadData.address
            headerVal[2] = this.$t('sales_center.stock_report')
        } else {
            headerVal[0] = this.reportHeadData.orgName
            headerVal[1] = this.reportHeadData.address
            headerVal[2] = this.$t('sales_center.stock_report')
        }
        return headerVal
    },
    excelData: function () {
        const listData = this.report_data
        var serial = 0
        const listContractor = listData.map(keyItem => {
            serial++
            if (this.$i18n.locale === 'en') {
                return {
                    'SL No': serial,
                    'Product Category': this.getCategoryName(keyItem),
                    'Product Sub Category': this.getSubCategoryName(keyItem),
                    'Product Name': this.getProductName(keyItem),
                    'Unit ': this.getUnitName(keyItem),
                    'Current Production Stock': this.getCurrentStock(keyItem)
                }
            } else {
            return {
                'ক্রমিক সংখ্যা': this.$n(serial),
                'পণ্যের ক্যাটাগরি': this.getCategoryName(keyItem),
                'পণ্যের সাব-ক্যাটাগরি': this.getSubCategoryName(keyItem),
                'পণ্যের নাম': this.getProductName(keyItem),
                'ইউনিট ': this.getUnitName(keyItem),
                'বর্তমান উৎপাদন স্টক': this.getCurrentStock(keyItem)
                 }
            }
        })
        return listContractor
    },
    categoryList: function () {
      return this.productCommonObj.productCategoryList.filter(item => item.status === 1)
    },
    currentLocale () {
      return this.$i18n.locale
    },
    columns () {
      const labels = [
          { label: this.$t('globalTrans.sl_no'), class: 'text-left' },
          { label: this.$t('production_store.pro_category'), class: 'text-left' },
          { label: this.$t('production_store.pro_sub_category'), class: 'text-left' },
          { label: this.$t('production_store.pro_name'), class: 'text-left' },
          { label: this.$t('production_store.unit'), class: 'text-left' },
          { label: this.$t('production_store.current_stock'), class: 'text-left' }
        ]

      let keys = []

      if (this.$i18n.locale === 'bn') {
        keys = [
          { key: 'index' },
          { key: 'category_name' },
          { key: 'sub_category_name' },
          { key: 'product_name' },
          { key: 'unit_id' },
          { key: 'current_stock' }
        ]
      } else {
        keys = [
          { key: 'index' },
          { key: 'category_name' },
          { key: 'sub_category_name' },
          { key: 'product_name' },
          { key: 'unit_id' },
          { key: 'current_stock' }
        ]
      }

      return labels.map((item, index) => {
          return Object.assign(item, keys[index])
        })
    },
    ...mapGetters({
      productCommonObj: 'ProductionService/commonObj'
    })
  },
  watch: {
    'search.category_id': function (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.subCategoryList = this.getSubCatList(newVal)
        this.productList = this.getProductListByCat(newVal)
      }
    },
    'search.sub_category_id': function (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.productList = this.getProductList(newVal)
      }
    },
     currentLocale: function (newVal, oldVal) {
        if (newVal !== oldVal) {
            }
            this.subCategoryList = this.getSubCatList(this.search.category_id)
            this.productList = this.getProductListByCat(this.search.category_id)
            this.productList = this.getProductList(this.search.sub_category_id)
            this.headerName()
        }
  },
  methods: {
    async headerName () {
       const headdata = await ReportHeading.getReportHead(productionServiceBaseUrl, 'configuration/report-heading/detail', 6)
       this.reportHeadData = headdata
       this.loaded = true
    },
    getSubCatList (catId) {
      return this.productCommonObj.productSubCategoryList.filter(item => item.status === 1 && item.category_id === catId && item.type_id === 2)
    },
    getProductListByCat (catId) {
      return this.productCommonObj.productList.filter(item => item.status === 1 && item.category_id === catId && item.type_id === 2)
    },
    getProductList (subCatId) {
      return this.productCommonObj.productList.filter(item => item.status === 1 && item.sub_category_id === subCatId && item.type_id === 2)
    },
    getCategoryName (catData) {
      let category = ''
      Object.keys(catData).forEach((value) => {
        const catId = parseInt(value)
        const catObj = this.categoryList.find(item => item.value === catId)
        if (this.$i18n.locale === 'bn') {
          category = catObj.text_bn
        } else {
          category = catObj.text_en
        }
      })
      return category
    },
    getSubCategoryName (SubcatData) {
      const Subcategory = []
      let name = ''
      Object.entries(SubcatData).forEach(([key, value]) => {
        Object.entries(value).forEach(([key, kvalue]) => {
          const productId = parseInt(key)
          const unitLength = Object.keys(kvalue).length
          const product = this.productCommonObj.productList.find(item => item.value === productId)
          const subCatId = parseInt(product.sub_category_id)
          if (subCatId !== 0) {
            const subCatObj = this.productCommonObj.productSubCategoryList.find(item => item.value === subCatId)
            if (this.$i18n.locale === 'bn') {
              name = subCatObj.text_bn
            } else {
              name = subCatObj.text_en
            }
            for (let i = 0; i < unitLength; i++) {
              Subcategory.push(name)
            }
          }
        })
      })
      return Subcategory
    },
    getProductName (prodData) {
      const productName = []
      let name = ''
      Object.entries(prodData).forEach(([key, value]) => {
        Object.entries(value).forEach(([key, value]) => {
          const productId = parseInt(key)
          const unitLength = Object.keys(value).length
          const product = this.productCommonObj.productList.find(item => item.value === productId)
          if (this.$i18n.locale === 'bn') {
            name = product.text_bn
          } else {
            name = product.text_en
          }
          for (let i = 0; i < unitLength; i++) {
            productName.push(name)
          }
        })
      })
      return productName
    },
    getUnitName (prodData) {
      const unitName = []
      Object.entries(prodData).forEach(([key, value]) => {
        Object.entries(value).forEach(([key, kvalue]) => {
          Object.keys(kvalue).forEach((unvalue) => {
            const unitId = parseInt(unvalue)
            const unit = this.productCommonObj.unitInfoList.find(item => item.value === unitId)
            if (this.$i18n.locale === 'bn') {
              unitName.push(unit.text_bn)
            } else {
              unitName.push(unit.text_en)
            }
          })
        })
      })
      return unitName
    },
    getCurrentStock (prodData) {
      const CurrentStock = []
      Object.entries(prodData).forEach(([key, value]) => {
        Object.entries(value).forEach(([key, kvalue]) => {
          Object.entries(kvalue).forEach(([key, value]) => {
            CurrentStock.push(this.$n(Math.floor(value[0].quantity)))
          })
        })
      })
      return CurrentStock
    },
    searchData () {
      this.loadData()
    },
    loadData () {
      const params = Object.assign({}, this.search, { page: this.pagination.currentPage, per_page: this.pagination.perPage })
      this.$store.dispatch('mutateCommonProperties', { loading: true, listReload: false })
      RestApi.getData(productionServiceBaseUrl, productStockReportList, params).then(response => {
          if (response.success) {
            this.report_data = response.data
            this.$store.dispatch('setList', response.data)
            // this.paginationData(response.data)
          }
          this.$store.dispatch('mutateCommonProperties', { loading: false, listReload: false })
      })
    },
    pdfExport () {
      const reportTitle = this.$t('production_store.stock_report')
      ExportPdf.exportPdfDetails(productionServiceBaseUrl, 'configuration/report-heading/detail', 6, reportTitle, this.report_data, this, this.monthname, this.year)
    }
  }
}
</script>
